import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderSubtitle, InfoPageHeaderTitle } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');
require('./style.css');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalPrivacyPolicyIT extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Privacy Policy';
		const siteDescription = 'Privacy Policy descrizione';
		const siteKeywords = 'Privacy Policy parole chiave';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/privacypolicy/it';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<InfoPageHeaderTitle>Privacy Policy</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<InfoPageHeaderSection>
						<InfoPageHeaderSubtitle>Unavailable content</InfoPageHeaderSubtitle>
					</InfoPageHeaderSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalPrivacyPolicyIT };
